import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";

import { allSharedComponents } from "../../../../../shared";
import { EventActions } from "../../../../../redux/actions";
import { sportNames } from "../../Spots/utilities";
import {
  Directions,
  fieldLengthConstants,
  translationConstants,
} from "../../../../../constants";
import { SearchBoxIcon } from "../../../../../assets/images/icon/iconsProvider";

const { ShowUserLevels } = allSharedComponents;

const AddParticipantModal = (props) => {
  const dispatch = useDispatch();
  const queryParameters = new URLSearchParams(window.location.search);
  const eventId = queryParameters.get("eventId");

  const userData = useSelector(
    (state) => state.eventReducer?.participant_details
  );

  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { t } = useTranslation();

  const [searchInput, setSearchInput] = useState("");

  const onSubmit = () => {
    dispatch(
      EventActions.addEventParticipant(
        { systemUserId: userData?.id, eventId: eventId },
        props.gridState,
        props.setShow,
        eventId,
        "adminPage"
      )
    );
  };

  const getSportNamesAndLevels = (sportLevels) => {
    // Map sportLevels to their corresponding names and levels
    const sportNamesAndLevels = sportLevels?.map(({ sportId, levelId }) => {
      const sportName = sportNames[sportId];
      const level = `Level ${levelId}`;
      return `${sportName} ${level}`;
    });

    //Join the names and levels with commas
    return sportNamesAndLevels.join(", ");
  };

  useEffect(() => {
    //Set initial form values from selected spot
    if (userData) {
      setValue("firstName", userData?.studentEnglishFirstName);
      setValue("firstNameArabic", userData?.studentArabicFirstName);
      setValue("lastName", userData?.studentEnglishLastName);
      setValue("lastNameArabic", userData?.studentArabicLastName);
      if (userData?.sportLevels) {
        const sportAndLevelsString = getSportNamesAndLevels(
          userData?.sportLevels
        );
        setValue("instructorLevel", sportAndLevelsString);
      }
    }

    // eslint-disable-next-line
  }, [userData]);

  const handleSearch = (e) => {
    e.preventDefault();
    setValue("firstName", "");
    setValue("firstNameArabic", "");
    setValue("lastName", "");
    setValue("lastNameArabic", "");
    setValue("email", "");
    dispatch(EventActions.getParticipantByEmail({ email: searchInput }));
  };

  //Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
  };

  return (
    <div>
      <Form
        noValidate
        className="ViewUserContent p-5 mx-4"
        onSubmit={handleSearch}
      >
        <div className="ViewHeader">
          <p className="viewUserPara">
            {t(translationConstants.addParticipant)}
          </p>
        </div>
        <p className="horizentalLine" />

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.SEARCH_SAILOR)}:
            </Form.Label>
            <div className="searchInputDivBGWhite d-flex justify-content-center bg-white align-items-center">
              <div className="d-flex bg-white w-100 p-0 pr-10 borderRadius-100">
                <input
                  type="text"
                  className="bg-white px-4 searchInputSecondary nonStyleRoundedField"
                  placeholder={t(translationConstants.Search)}
                  onChange={handleSearchChange}
                />
              </div>
              <div className="px-3 pt-1 cursor-pointer">
                <SearchBoxIcon onClick={handleSearch} />
              </div>
            </div>
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.firstName)}:
            </Form.Label>
            <Form.Control
              {...register("firstName", {})}
              id="firstName"
              type="text"
              className="bg-gray"
              disabled={true}
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
            />
          </Form.Group>

          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.lastName)}:
            </Form.Label>
            <Form.Control
              {...register("lastName", {})}
              id="lastName"
              className="bg-gray"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              disabled={true}
            />
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.firstNameArabic)}:{" "}
              <span>{t(translationConstants.optional)}</span>{" "}
            </Form.Label>
            <Form.Control
              {...register("firstNameArabic", {})}
              id="firstNameArabic"
              className="bg-gray"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              style={{ direction: Directions.rtl }}
              disabled={true}
            />
          </Form.Group>

          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.lastNameArabic)}:{" "}
              <span>{t(translationConstants.optional)}</span>
            </Form.Label>
            <Form.Control
              {...register("lastNameArabic", {})}
              id="lastNameArabic"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              className="bg-gray"
              style={{ direction: Directions.rtl }}
              disabled={true}
            />
          </Form.Group>
        </div>

        {userData?.levels && (
          <div className="row mt-3">
            <label className="Form-labels form-label">
              {t(translationConstants.SAILOR_LEVEL)}:
            </label>
            <ShowUserLevels userLevels={userData?.levels} />
          </div>
        )}

        <div className="row d-flex justify-content-center mt-4">
          <div className="col-lg-4">
            {userData == null ? (
              <Button
                className="UpdateUserView-button w-100"
                type="button"
                disabled={true}
                onClick={handleSubmit(onSubmit)}
              >
                {t(translationConstants.addParticipant)}
              </Button>
            ) : (
              <Button
                className="UpdateUserView-button w-100"
                type="button"
                onClick={handleSubmit(onSubmit)}
              >
                {t(translationConstants.addParticipant)}
              </Button>
            )}
            <Button className="d-none" type="submit"></Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AddParticipantModal;
